import { z } from 'zod'

export const remittanceSchema = z.object({
  nameOfPayer: z.string(),
  paidDate: z.string(),
  amount: z.string(),
  entryType: z.enum(['payment', 'transfer']),
})

export const remittanceListSchema = z.array(remittanceSchema)

export type TRemittance = z.infer<typeof remittanceSchema>
